import { c as _c } from "react/compiler-runtime";
import type { FormSection } from '@/features/payload-cms/components/form/types';
import { type Locale, type StaticTranslationString } from '@/types/types';
import React from 'react';
const stepText: StaticTranslationString = {
  en: 'Step',
  de: 'Schritt',
  fr: 'Étape'
};
const ofText: StaticTranslationString = {
  en: 'of',
  de: 'von',
  fr: 'de'
};
interface ProgressBarProperties {
  locale: Locale;
  currentStepIndex: number;
  definedSteps: FormSection[];
  currentActualStep: FormSection;
}
export const ProgressBar: React.FC<ProgressBarProperties> = t0 => {
  const $ = _c(13);
  const {
    locale,
    currentStepIndex,
    definedSteps,
    currentActualStep
  } = t0;
  const t1 = stepText[locale];
  const t2 = currentStepIndex + 1;
  const t3 = ofText[locale];
  let t4;
  if ($[0] !== definedSteps.length || $[1] !== t1 || $[2] !== t2 || $[3] !== t3) {
    t4 = <div className="text-conveniat-green mb-2 flex justify-between text-sm font-medium"><span>{t1} {t2} {t3} {definedSteps.length}</span></div>;
    $[0] = definedSteps.length;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = `${(currentStepIndex + 1) / definedSteps.length * 100}%`;
  let t6;
  if ($[5] !== t5) {
    t6 = <div className="h-2 w-full rounded-full bg-gray-200"><div className="bg-conveniat-green h-2 rounded-full transition-all duration-300 ease-in-out" style={{
        width: t5
      }} /></div>;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = "sectionTitle" in currentActualStep && currentActualStep.sectionTitle;
  let t8;
  if ($[7] !== t7) {
    t8 = <div className="mt-2 text-xs text-gray-600">{t7}</div>;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t4 || $[10] !== t6 || $[11] !== t8) {
    t9 = <div className="mb-6">{t4}{t6}{t8}</div>;
    $[9] = t4;
    $[10] = t6;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  return t9;
};